import { Board } from '../types'
import BoardPreview from './BoardPreview'
import useDaily5State from '../hooks/useDaily5State'

const DailyBoardPreview = () => {
	const daily5State = useDaily5State()
	const board: Board = daily5State ? daily5State.board : []

	const colCount = board.length
	const letters: string[] = []

	for (let row = 0; row < colCount; row++) {
		for (let col = colCount - 1; col >= 0; col--) {
			if (board[col][row]) {
				letters.push(board[col][row])
			}
		}
	}

	letters.reverse()

	return <BoardPreview letters={letters.join('')} cols={board.length} />
}

export default DailyBoardPreview
